import { Fallbacks } from '../types';
import ADD_ONS_FALLBACKS from './add-ons';
import CUSTOMIZE_FALLBACKS from './customize';
import EDIT_FALLBACKS from './edit';
import GIFTING_FALLBACKS from './gifting';
import HOMEPAGE_FALLBACKS from './homepage';
import SHOP_FALLBACKS from './shop';
import UPGRADE_CONFIRMATION_FALLBACKS from './upgrade-confirmation';

const fallbacks: Fallbacks = {
  ...ADD_ONS_FALLBACKS,
  ...CUSTOMIZE_FALLBACKS,
  ...EDIT_FALLBACKS,
  ...HOMEPAGE_FALLBACKS,
  ...UPGRADE_CONFIRMATION_FALLBACKS,
  ...SHOP_FALLBACKS,
  ...GIFTING_FALLBACKS,
};

export default fallbacks;
